import type { IApplicationState } from 'shared/types/redux';
import { INewbuildingsPlusBlocksPikContractSchema } from 'shared/repositories/special-promos/entities/newbuildings_plus_blocks_pik_contract/NewbuildingsPlusBlocksPikContractSchema';

export function newbuildingsPlusBlocksPikSelector(
  state: IApplicationState,
): INewbuildingsPlusBlocksPikContractSchema[] {
  return state.specialPromosBlocks.newbuildingsPlusBlocksPik;
}
